module.exports = __webpack_public_path__ + "static/media/content-camel-logo.f10ed9f4.png";